/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const oneTrustWebPrivacyPath = "https://www.adobe.com/etc/beagle/public/globalnav/adobe-privacy/latest/privacy.min.js";

// Check for measure performance only
const availableCookies = ["C0001", "C0002"]; // ["C0001", "C0002", "C0003", "C0004"];

export default class CMPToolService {
    initialize(config) {
        this._config = config;
        this._pendingReadyPromise = true;
        this._readyPromise = new Promise(resolve => {
            this._readyResolve = resolve;
        });
        const initCMP = !(this._config.disableCMPTool);
        if (initCMP) {
            this._registerForEvents();
            this._loadScript();
        } else {
            this._updateConsent(!this._config.disableMeasurePerformance);
        }
    }

    ready() {
        return this._readyPromise;
    }

    _markReady() {
        if (this._pendingReadyPromise) {
            this._readyResolve();
            this._pendingReadyPromise = false;
        }
    }

    _updateConsent(consent) {
        window.adobe_dc_sdk.gdpr_consent = consent;
        this._markReady();
    }

    _registerForEvents() {
        window.adobe_dc_sdk.gdpr_consent = false;
        window.addEventListener("adobePrivacy:PrivacyConsent", () => {
            this._updateConsent(true);
        });
        window.addEventListener("adobePrivacy:PrivacyReject", () => {
            this._updateConsent(false);
        });
        window.addEventListener("adobePrivacy:PrivacyCustom", () => {
            this._checkForConsent();
        });
    }

    _checkForConsent() {
        // returns array with cookie category/host strings
        const allowedCookieGroups = window.adobePrivacy.activeCookieGroups();
        let allCookiesAccepted = true;
        // eslint-disable-next-line one-var
        for (let i = 0; i < availableCookies.length; i += 1) {
            if (allowedCookieGroups.indexOf(availableCookies[i]) === -1) {
                allCookiesAccepted = false;
                break;
            }
        }

        this._updateConsent(allCookiesAccepted);
    }

    _loadScript() {
        // Variables that needs to be set for OneTrust Banner
        window.fedsConfig = window.fedsConfig || {};
        window.fedsConfig.privacy = window.fedsConfig.privacy || {};
        window.fedsConfig.privacy.otDomainId = this._config.otDomainId;
        // footerLinkSelector is required for the banner to show up
        window.fedsConfig.privacy.footerLinkSelector = ".one-trust-notice";
        window.adobe_dc_sdk.dom.loadScript(oneTrustWebPrivacyPath);
    }
}
